import styled from 'styled-components'

import { Button } from '@syconium/little-miss-figgy'

export const CtaButton = styled(Button)`
  margin: ${props => props.theme.spacing(4)} 0;
`
